import React from 'react'
import {GoogleMap, InfoWindow, Marker, withGoogleMap} from "react-google-maps"

import red from '../../img/red-dot.png'
import blue from '../../img/blue-dot.png'

const InitialMap = withGoogleMap(props => {

    const route = {
        "geocoded_waypoints": [{
            "geocoder_status": "OK",
            "place_id": "EigyMzk5IFMgTW9yZ2FuIFN0LCBDaGljYWdvLCBJTCA2MDYwOCwgVVNB",
            "types": ["street_address"]
        }, {
            "geocoder_status": "OK",
            "place_id": "EigxMDAxIFcgQ2VybWFrIFJkLCBDaGljYWdvLCBJTCA2MDYwOCwgVVNB",
            "types": ["street_address"]
        }],
        "routes": [{
            "bounds": {
                "south": 41.85076,
                "west": -87.65141000000001,
                "north": 41.85257,
                "east": -87.65126000000001
            },
            "copyrights": "Map data ©2017 Google",
            "legs": [{
                "distance": {"text": "0.1 mi", "value": 203},
                "duration": {"text": "1 min", "value": 76},
                "end_address": "1001 W Cermak Rd, Chicago, IL 60608, USA",
                "end_location": {"lat": 41.8525704, "lng": -87.65140550000001},
                "start_address": "2399 S Morgan St, Chicago, IL 60608, USA",
                "start_location": {"lat": 41.8507582, "lng": -87.6512578},
                "steps": [{
                    "distance": {"text": "0.1 mi", "value": 203},
                    "duration": {"text": "1 min", "value": 76},
                    "end_location": {"lat": 41.8525704, "lng": -87.65140550000001},
                    "polyline": {"points": "g~l~Fjk~uOiHFU@OBYN"},
                    "start_location": {"lat": 41.8507582, "lng": -87.6512578},
                    "travel_mode": "DRIVING",
                    "encoded_lat_lngs": "g~l~Fjk~uOiHFU@OBYN",
                    "path": [{"lat": 41.85076, "lng": -87.65126000000001}, {
                        "lat": 41.852250000000005,
                        "lng": -87.6513
                    }, {"lat": 41.852360000000004, "lng": -87.65131000000001}, {
                        "lat": 41.85244,
                        "lng": -87.65133
                    }, {"lat": 41.85257, "lng": -87.65141000000001}],
                    "lat_lngs": [{"lat": 41.85076, "lng": -87.65126000000001}, {
                        "lat": 41.852250000000005,
                        "lng": -87.6513
                    }, {"lat": 41.852360000000004, "lng": -87.65131000000001}, {
                        "lat": 41.85244,
                        "lng": -87.65133
                    }, {"lat": 41.85257, "lng": -87.65141000000001}],
                    "instructions": "Head <b>north</b> on <b>S Morgan St</b> towards <b>W Cermak Rd</b>",
                    "maneuver": "",
                    "start_point": {"lat": 41.8507582, "lng": -87.6512578},
                    "end_point": {"lat": 41.8525704, "lng": -87.65140550000001}
                }],
                "traffic_speed_entry": [],
                "via_waypoint": [],
                "via_waypoints": []
            }],
            "overview_polyline": "g~l~Fjk~uO_IHi@R",
            "summary": "S Morgan St",
            "warnings": [],
            "waypoint_order": [],
            "overview_path": [{"lat": 41.85076, "lng": -87.65126000000001}, {
                "lat": 41.852360000000004,
                "lng": -87.65131000000001
            }, {"lat": 41.85257, "lng": -87.65141000000001}]
        }],
        "status": "OK",
        "request": {
            "origin": {"lat": 41.85073, "lng": -87.65125999999998},
            "destination": {"lat": 41.85258, "lng": -87.65141},
            "travelMode": "DRIVING"
        }
    };

    return (
        <GoogleMap ref={props.onMapLoad}
                   defaultZoom={9}
                   defaultCenter={{lat: 50.035996, lng: 21.964681,}}>
            {props.markers.map((item, index) => {
                if (item.nazPr === props.nazPrDo || item.nazPr === props.nazPrOd) {
                    return (
                        <Marker
                            key={index}
                            position={{lat: item.szGps, lng: item.dlGps}}
                            onClick={() => props.onMarkerClick(item)}
                            icon={blue}
                        >
                            {item.showInfo && (
                                <InfoWindow onCloseClick={() => props.onMarkerClose(item)}>
                                    {
                                        <div id="infowindow" style={{minWidth: 250}}>
                                            <div style={{
                                                fontSize: '1rem',
                                                fontWeight: 'bold'
                                            }}>{item.nazMi} {item.nazPr}</div>
                                            <div className="row" style={{paddingTop: 5, width: '90%'}}>
                                                <div className="col-sm-6"><i className="fa fa-clock-o"> </i> {item.godz}
                                                </div>
                                                <div className="col-sm-6"><i
                                                    className="fa fa-map-signs"> </i> {item.km} km
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </InfoWindow>
                            )}
                        </Marker>
                    )
                } else {
                    return (
                        <Marker
                            key={index}
                            position={{lat: item.szGps, lng: item.dlGps}}
                            onClick={() => props.onMarkerClick(item)}
                            icon={red}
                        >
                            {item.showInfo && (
                                <InfoWindow onCloseClick={() => props.onMarkerClose(item)}>
                                    {
                                        <div id="infowindow" style={{minWidth: 250}}>
                                            <div style={{
                                                fontSize: '1rem',
                                                fontWeight: 'bold'
                                            }}>{item.nazMi} {item.nazPr}</div>
                                            <div className="row" style={{paddingTop: 5, width: '90%'}}>
                                                <div className="col-sm-6"><i className="fa fa-clock-o"> </i> {item.godz}
                                                </div>
                                                <div className="col-sm-6"><i
                                                    className="fa fa-map-signs"> </i> {item.km} km
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </InfoWindow>
                            )}
                        </Marker>
                    )
                }
            })
            }
        </GoogleMap>
    )

});

export default InitialMap



// WEBPACK FOOTER //
// ./src/components/wyszukiwarka/wyszukiwarkaComponents/InitialMap.js